import { ApiResult } from 'interfaces/APITypes';
import { ActivationFormData, PasswordResetFormData } from 'interfaces/FormData';
import { InviteUserPayload } from 'interfaces/user/InviteUser';
import { User } from 'interfaces/user/User';
import { GridRowId } from '@mui/x-data-grid';

import { ServerSideFilter } from 'components/mytover/invite/UnitUserFilterSection';

import { makeRequest, mytoverInstance } from './client';

export const getUser = async (id?: number | string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/user' + (id ? 's/' + id : '')));
};

export const getUserUnits = async (id?: number | string, values?: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/users/${id}/units`, { params: values }));
};

export const getUserActivity = async (id?: number | string, values?: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/users/${id}/activity`, { params: values }));
};

export const getUsers = async (values?: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/users', { params: values }));
};

export const getInvitedUser = async (id: string, token: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/users/${id}/${token}`));
};

export const getRelatedUsers = async (values: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/unit-user-relations', { params: values }));
};

export const inviteUsers = async (values: InviteUserPayload): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/users/invite', values));
};

export const getUserInviteOptions = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/user/invite-options'));
};

export const resendInvitation = async (id: GridRowId): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/users/${id}/resend-invitation`));
};

export const removeUser = async (id: GridRowId, serial: GridRowId): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.delete(`/units/${serial}/users/${id}`));
};

export const deleteUser = async (user: User): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.delete(`/users/${user.id}`));
};

export const editUser = async (id: string, serial: string, role: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.patch(`/units/${serial}/users/${id}`, { role }));
};

export const removeUserUnitRelation = async (id: number): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.delete(`/unit_user/${id}`));
};

export const requestInvite = async (values: { serial_number: string; email?: string }): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/user/request-invite', values));
};

export const acceptInvite = async (token: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/users/accept-invite/${token}`));
};

export const setPasswordActivation = async (values: ActivationFormData): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/user/activate', values));
};

export const requestPasswordReset = async (email: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/user/reset-password', { email }));
};

export const sendPasswordReset = async (payload: PasswordResetFormData): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/user/reset-password/${payload.token}`, payload));
};
